import global from "@/locales/pl-PL/global";
import error403 from "@/locales/pl-PL/errors/403";
import error404 from "@/locales/pl-PL/errors/404";
import error500 from "@/locales/pl-PL/errors/500";
import error503 from "@/locales/pl-PL/errors/503";
import error504 from "@/locales/pl-PL/errors/504";
import maintenance from "@/locales/pl-PL/auth/maintenance";
import toast from "@/locales/pl-PL/toast/toast";
import login from "@/locales/pl-PL/auth/login";
import onboarding from "@/locales/pl-PL/auth/onboarding";
import loginPageSteps from "@/locales/pl-PL/loginPageSteps";
import dashboard from "@/locales/pl-PL/dashboard/dashboard";
import account from "@/locales/pl-PL/account/account";
import mailbox from "@/locales/pl-PL/account/mailbox";
import bankstatement from "@/locales/pl-PL/account/bankstatement";
import myApps from "@/locales/pl-PL/my-apps/myApps";
import about from "@/locales/pl-PL/about/about";
import contactService from "@/locales/pl-PL/about/contactService";
import salesPromotions from "@/locales/pl-PL/sales/promotions";
import brochures from "@/locales/pl-PL/sales/brochures";
import shop from "@/locales/pl-PL/shop/data";
import priceList from "@/locales/pl-PL/shop/priceList";
import staff from "@/locales/pl-PL/dashboard/staff";
import promotions from "@/locales/pl-PL/promotions";
import points from "@/locales/pl-PL/points";
import trainings from "@/locales/pl-PL/trainings/trainings";
import vouchers from "@/locales/pl-PL/vouchers/vouchers";
import media from "@/locales/pl-PL/media/index";
import product from "@/locales/pl-PL/product/index";
import message from "@/locales/pl-PL/message/index";
import commitmentLetter from "@/locales/pl-PL/account/commitmentLetter";
import multiplicator from "@/locales/pl-PL/multiplicator";
import widgets from "@/locales/pl-PL/widgets/widgets";
import consents from "@/locales/pl-PL/consents/consents";
import investment from "@/locales/pl-PL/investment/data";
import kickback from "@/locales/pl-PL/kickback";
import portalHome from "@/locales/pl-PL/portal-home/portalHome";

//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  widgets: widgets.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  portalHome: portalHome.messages,
  productBrochures: {
    BDriveTitle: "Zdjęcia produktów",
    BDriveLinkText: "Link do portalu ZDJĘĆ PRODUKTÓW",
  },
}

export default {
  locale: "pl-PL",
  messages,
};
